<template>
  <server-table
    ref="table"
    table-class="table-sm"
    :api-request="apiRequest"
    :columns="table.columns"
    :busy.sync="table.loading"
    :sort-by.sync="table.sortBy"
    :sort-desc="true"
    :searchable="false"
    striped
    @refreshed="onRefreshed"
  >
    <div slot="beforeSearch" class="flex-grow-1">
      <b-media vertical-align="center">
        <template #aside>
          <b-btn
            variant="outline-secondary"
            size="sm"
            @click="$root.$emit('operation.view', { name: 'devices' })"
          >
            <b-icon icon="arrow-left" />
          </b-btn>
        </template>
        <h4 class="m-0">
          História <small>({{ count }})</small>
        </h4>
        <div class="fs-lg">
          {{ data.name }} <small>({{ data.serialNumber }})</small>
        </div>
      </b-media>
    </div>
    <template #cell(eventId)="data">
      <template v-if="data.value === 1">
        <b-icon class="mr-1 text-success" icon="plus" scale="1.5x" />
        Pridané
      </template>
      <template v-else-if="data.value === 2">
        <b-icon class="mr-1 text-warning" icon="pencil" />
        Upravené
      </template>
    </template>
    <template #cell(oldValues)="data">
      <ul class="pl-3 mb-0">
        <li
          v-for="(item, key) in data.item.data"
          v-if="key !== 'updatedAt'"
          :key="key"
          class="text-muted"
        >
          <strong>{{ historyItems[key] }}:</strong>
          {{ data.item.data[key][0] }}
        </li>
      </ul>
    </template>
    <template #cell(newValues)="data">
      <ul class="pl-3 mb-0">
        <li
          v-for="(item, key) in data.item.data"
          v-if="key !== 'updatedAt'"
          :key="key"
        >
          <strong>{{ historyItems[key] }}:</strong>
          {{ data.item.data[key][1] }}
        </li>
      </ul>
    </template>
  </server-table>
</template>
<script>
import ServerTable from '@/components/ServerTable'
import operationService from '@/services/api/operationService'

export default {
  components: {
    ServerTable,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      count: null,
      table: {
        loading: false,
        columns: [
          {
            key: 'eventId',
            label: 'Udalosť',
            class: 'text-nowrap',
            sortable: true,
          },
          {
            key: 'oldValues',
            label: 'Pôvodné hodnoty',
          },
          {
            key: 'newValues',
            label: 'Nové hodnoty',
          },
          {
            key: 'createdDateTime',
            label: 'Dátum a čas',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
          },
          {
            key: 'createdBy',
            label: 'Užívateľ',
            formatter: (value, key, item) =>
              item.userAuth
                ? item.userAuth.firstName + ' ' + item.userAuth.lastName
                : '-',
          },
        ],
        sortBy: 'createdDateTime',
      },
    }
  },
  computed: {
    historyItems() {
      return {
        floor: 'Podlažie',
        invoiceMultiplier: 'Fakt. násobiteľ',
        isActive: 'Stav',
        mainName: 'Názov OM',
        measureType: 'Typ merania',
        name: 'Názov OM',
        note: 'Poznámka',
        section: 'Sekcia',
        serialNumber: 'Sériové číslo',
      }
    },
  },
  methods: {
    onRefreshed() {
      this.count = this.$refs.table.totalRows
    },
    apiRequest(params) {
      return operationService
        .getDeviceAuditLogs(this.data.id, {
          ...this.table.filter,
          orderBy: params.orderBy,
          maxResults: params.maxResults,
          startAt: params.startAt,
        })
        .then((res) => {
          res.data = {
            filtered: params.maxResults,
            total: res.headers['x-pagination-total-count']
              ? res.headers['x-pagination-total-count']
              : 0,
            rows: res.data,
          }
          return res
        })
    },
  },
}
</script>
